<template>
  <el-form class="search-form"  style="margin-left: -20px;">
    <el-form-item label="平台" :label-width="formLabelWidth">
      <el-select
        placeholder="请选择"
        v-model="searchform.platform"
        autocomplete="on"
        size="small"
        clearable
        filterable
      >
        <el-option
          v-for="(item,i) in plateList"
          :key="i"
          :label="item.dictName"
          :value="item.dictCode"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="店铺名称" :label-width="formLabelWidth">
      <el-input v-model="searchform.shopname" placeholder="请输入" size="small" clearable></el-input>
    </el-form-item>
    <el-form-item label="举报时间" :label-width="formLabelWidth">
      <el-date-picker
        v-model="dateTime"
        size="small"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        range-separator="~"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label="举报ID" :label-width="formLabelWidth">
      <el-input placeholder="请输入" size="small" v-model="searchform.reportid" clearable></el-input>
    </el-form-item>
    <el-form-item label="产品信息" :label-width="formLabelWidth" v-if="productShow">
      <el-input placeholder="请输入" size="small" v-model="searchform.productinfo" clearable></el-input>
    </el-form-item>
    <el-form-item label="经销商名称:" :label-width="formLabelWidth" v-if="dealerShow">
      <el-select
        placeholder="请选择"
        v-model="searchform.dealerid"
        autocomplete="on"
        size="small"
        clearable
      >
        <el-option
          v-for="(item,i) in dealData"
          :key="i"
          :label="item.dealername"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label-width="formLabelWidth" label="处理状态:" v-if="dealState">
      <el-select
        placeholder="请选择"
        v-model="searchform.flowids"
        autocomplete="on"
        size="small"
        clearable
      >
        <el-option
          v-for="(item,i) in dealStateInfo"
          :key="i"
          :label="item.name"
          :value="item.flowids"
        ></el-option>
      </el-select>
    </el-form-item>
    <!--汇总显示-->
    <el-form-item :label-width="formLabelWidth" label="违规类型" v-if="collectShow">
      <el-select placeholder="请选择" v-model="searchform.reason" clearable size="small">
        <el-option
          v-for="(item,i) in getOutType"
          :key="i"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
    </el-form-item>
    <slot name="searchSort"></slot>
    <el-form-item>
    </el-form-item>
    <el-form-item>
    </el-form-item>
    <el-form-item>
      <el-button size="small" class="search-btn1" v-if="collectShow" @click="downExcel">下载数据</el-button>
      <el-button size="small" class="search-btn" @click="searchReportPage">查询</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters, mapMutations, mapActions ,mapState} from "vuex";
import { getSinceThreeMonth } from "@/libs/date";

export default {
  name: "headerSearch",
  props: {
    dealState: {
      //处理状态是否显示
      type: Boolean
    },
    collectShow: {
      type: Boolean
    },
    productShow: {
      type: Boolean,
      default: false
    },
    dealerShow: {
      type: Boolean,
      default: false
    },
    fullStatus: {
      //全部处理状态
      type: Boolean,
      default: false
    },
    unauthorizative: {
      //非授权处理状态
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '今日',
          onClick:(picker) => {
            this.getRecentDate(picker,1);
          }
        },{
          text: '近7日',
          onClick:(picker) => {
            this.getRecentDate(picker,7);
          }
        }, {
          text: '近15日',
          onClick:(picker) => {
            this.getRecentDate(picker,15);
          }
        }, {
          text: '近30日',
          onClick:(picker) => {
            this.getRecentDate(picker,30);
          }
        }, {
          text: '近90日',
          onClick:(picker) => {
            this.getRecentDate(picker,90);
          }
        }, {
          text: '近365日',
          onClick:(picker) => {
            this.getRecentDate(picker,365);
          }
        }]
      },
      formLabelWidth: "100px",
      collectList: [], //违规类型
      //处理状态
      dealStateInfo: [],
      //搜索条件
      searchform: {
        flowids: "",
        platform: ""
      },
      dateTime: [],
      dealData: []
    };
  },
  created() {
    this.getlistOfBmc()
    this.reqPlateList();
    this.dateTime = [
      getSinceThreeMonth()[0].slice(0, 10),
      getSinceThreeMonth()[1].slice(0, 10)
    ];
    this.commonHeaderSearch(this.getSearch());
    this.$emit('firstGetSearch',this.getSearch())
    if (this.collectShow) this.getInstallListByReportId();
    // if (this.fullStatus) {
    //   //全部处理状态
    //   this.dealStateInfo.splice(1, 0, { name: "待处理", flowids: 11 });
    //   this.dealStateInfo.splice(2, 0, { name: "已处理", flowids: 12 });
    // }
    if (this.unauthorizative) {
      this.dealStateInfo = [
        {
          name: "待处理",
          flowids: '11'
        },
        {
          name: "已处理",
          flowids: '12'
        }
      ];
    } else {
      this.dealStateInfo = [
        {
          name: "初审中",
          flowids: '0'
        },
        {
          name: "处理中",
          flowids: '11'
        },
        {
          name: "店铺响应中",
          flowids: '1,13'
        },
        {
          name: "店铺已整改-复查中",
          flowids: '2'
        },
        {
          name: "店铺已申诉-评定中",
          flowids: '5'
        },
        {
          name: "异常举报",
          flowids: '10'
        },
        {
          name: "已结案",
          flowids: '9'
        },
        {
          name: "已处理",
          flowids: '12'
        }
      ];
    }
  },
  computed: {
    ...mapGetters(["plateList"]),
     ...mapState({
      creditSearchData: state => state.creditScore.creditSearchData,
       InstallList: state => state.creditScore.InstallList,
      unauthorizativeType: state => state.creditScore.unauthorizativeType,
    }),
    getOutType(){
      return this.InstallList.concat(this.unauthorizativeType)
    }
  },
  methods: {
    ...mapActions(["reqPlateList"]),
    ...mapMutations(["commonHeaderSearch"]),
    getRecentDate(picker,n) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * n);
      if(picker){
        picker.$emit('pick', [start, end]);
      }
      if (n === 1) {
        this.dateTime[0] = this.$options.filters['fullTime'] (end).substring(0, 10);
        this.dateTime[1] = this.$options.filters['fullTime'] (end).substring(0, 10);
      } else {
        this.dateTime[0] = this.$options.filters['fullTime'] (start).substring(0, 10);
        this.dateTime[1] = this.$options.filters['fullTime'] (end).substring(0, 10);
      }
    },
    getSearch() {
      let data = {
        ...this.searchform,
        starttime: this.dateTime ? this.dateTime[0] : "",
        endtime: this.dateTime ? this.dateTime[1] : ""
      };
      if(!data.flowids) delete data.flowids
      return data;
    },
    searchReportPage() {
      //查询
      this.commonHeaderSearch(this.getSearch());
      this.$emit("searchTable", this.getSearch());
    },
    getInstallListByReportId() {
      //初始化
      fetch({
        url: "hcm/hcmReport/getInstallListByReportId",
        method: "get",
        params: {
          type: 2
        }
      }).then(res => {
        if (res.status == "10000") {
          this.collectList = res.data;
        }
      });
    },
    getlistOfBmc() {
      //初始化
      fetch({
        url: "hcm/dealer/getlistOfBmc",
        method: "get",
      }).then(res => {
        if (res.status == "10000") {
          this.dealData = res.data
        }
      });
    },
    downExcel() {
      this.$emit("exportExcel", this.searchform);
    }
  }
};
</script>

<style lang="scss">
.search-form-flex {
  .search-btn1 {
    float: right;
    margin-left: 15px;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .el-form-item {
    width: 33%;
    max-width: 500px;
    min-width: 300px;
    vertical-align: text-top;
    margin: 0 20px 18px 0;
  }
  .el-date-editor--daterange,
  .el-select,
  .el-cascader {
    width: 100%;
  }
  .search-btn {
    letter-spacing: 6px;
    padding-right: 6px;
    float: right;
  }
}
</style>
